var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { useContext, useEffect, useRef, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { createTaskRequest } from "../../../api/api";
import { WPQTInput } from "../../../components/common/Input/Input";
import { LoadingOval } from "../../../components/Loading/Loading";
import { PIPELINE_ADD_TASK } from "../../../constants";
import { ActivePipelineContext } from "../../../providers/ActivePipelineContextProvider";
function AddTask({ stageId }) {
    const [taskName, setTaskName] = useState("");
    const [showTaskInput, setShowTaskInput] = useState(false);
    const [loading, setLoading] = useState(false);
    const componentRef = useRef(null);
    const inputRef = useRef(null);
    const { state: { activePipeline }, dispatch, } = useContext(ActivePipelineContext);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter" &&
                document.activeElement === inputRef.current) {
                createTask();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [taskName]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current &&
                !componentRef.current.contains(event.target)) {
                clearState();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        var _a;
        if (showTaskInput) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [showTaskInput]);
    const createTask = () => __awaiter(this, void 0, void 0, function* () {
        if (!taskName) {
            toast.error(__("Task name is required", "quicktasker"));
            return;
        }
        try {
            setLoading(true);
            const response = yield createTaskRequest(stageId, activePipeline.id, taskName);
            dispatch({
                type: PIPELINE_ADD_TASK,
                payload: response.data,
            });
            clearState();
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to create task", "quicktasker"));
        }
        finally {
            setLoading(false);
        }
    });
    const clearState = () => {
        setShowTaskInput(false);
        setTaskName("");
    };
    return (_jsx("div", { ref: componentRef, className: "wpqt-sticky wpqt-bottom-0 wpqt-z-10 wpqt-order-1 wpqt-mt-2 wpqt-flex wpqt-justify-center wpqt-bg-gray-100 wpqt-py-2", children: showTaskInput ? (_jsxs("div", { className: "wpqt-flex wpqt-items-center wpqt-gap-3", children: [_jsx(WPQTInput, { ref: inputRef, value: taskName, onChange: (value) => setTaskName(value), wrapperClassName: "!wpqt-mb-0", className: "!wpqt-mb-0" }), loading ? (_jsx(LoadingOval, { width: "24", height: "24" })) : (_jsxs(_Fragment, { children: [_jsx(XCircleIcon, { className: "wpqt-icon-red wpqt-size-6 wpqt-cursor-pointer", onClick: clearState }), _jsx(PlusCircleIcon, { className: "wpqt-icon-green wpqt-size-6 wpqt-cursor-pointer", onClick: createTask })] }))] })) : (_jsxs("div", { onClick: () => setShowTaskInput(true), className: "wpqt-main-border wpqt-flex wpqt-cursor-pointer wpqt-items-center wpqt-justify-center wpqt-gap-2 wpqt-p-2 hover:wpqt-bg-white", children: [__("Add task", "quicktasker"), _jsx(PlusCircleIcon, { className: "wpqt-size-6 wpqt-text-green-600" })] })) }));
}
export { AddTask };
